export default `
... on Homepage_Homepagebuilder_rows_Content_RichTextBlock{
   fieldGroupName
   content
}`;
